import { db } from '../firebase';
import { collection, doc, addDoc, getDocs, query, deleteDoc } from 'firebase/firestore';

export interface Shift {
  id?: string;
  tenantId: string;
  shiftName: string;
  startTime: string;
  endTime: string;
}

export const getShifts = async (tenantId: string): Promise<Shift[]> => {
  const shiftsRef = collection(db, 'tenants', tenantId, 'shifts');
  const q = query(shiftsRef);
  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  } as Shift));
};

export const saveShift = async (tenantId: string, shift: Shift) => {
  const shiftsRef = collection(db, 'tenants', tenantId, 'shifts');
  await addDoc(shiftsRef, shift);
};

export const deleteShift = async (tenantId: string, shiftId: string) => {
  const shiftRef = doc(db, 'tenants', tenantId, 'shifts', shiftId);
  await deleteDoc(shiftRef);
};
